const toitureItemData = [
    {
        blocTitle: 'Je sélectionne ma couverture de toiture',
        blocContent: [
            {
                imageUrl : '/assets/images/Terrace-extérieure.png',
                title: 'TUILE Mécanique',
                description: 'Terrace extérieure',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'TUILE Autre',
                description: 'Bardages extérieur',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'Plaque FIBRO',
                description: 'Lambris intérieure',
            },
            {
                imageUrl : '/assets/images/Parquet-intérieur.png',
                title: 'Plaque BAC ACIER',
                description: 'Parquet intérieur',
            },
        ],
        hasInput: false,
        inputLabel: '',
        inputDescription: '',
    },
    {
        blocTitle: 'Je sélectionne mon isolation de toiture',
        blocContent: [
            {
                imageUrl : '/assets/images/Terrace-extérieure.png',
                title: 'PAS D\'ISOLATION',
                // description: 'Terrace extérieure',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'TUILE Autre',
                // description: 'Bardages extérieur',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'Plaque FIBRO',
                // description: 'Lambris intérieure',
            },
            {
                imageUrl : '/assets/images/Parquet-intérieur.png',
                title: 'Plaque BAC ACIER',
                // description: 'Parquet intérieur',
            },
        ],
        hasInput: true,
        inputLabel: 'Quelle épaisseur ?',
        inputDescription: 'La RE 2020 conseille une isolation minimum de 300mm sous toiture !',
    },
    {
        blocTitle: 'Je sélectionne mon plafond de sous-toiture',
        blocContent: [
            {
                imageUrl : '/assets/images/Terrace-extérieure.png',
                title: 'PAS DE PLAFOND',
                // description: 'Terrace extérieure',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'LAMBRIS',
                // description: 'Bardages extérieur',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'PLACO-PLASTER',
                // description: 'Lambris intérieure',
            },
        ],
        hasInput: false,
        inputLabel: '',
        inputDescription: '',
    },
    {
        blocTitle: 'Je sélectionne mes supports de couverture',
        blocContent: [
            {
                imageUrl : '/assets/images/Terrace-extérieure.png',
                title: 'LITAUX',
                // description: 'Terrace extérieure',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'HPV + LITAUX',
                // description: 'Bardages extérieur',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'VOLIGE',
                // description: 'Lambris intérieure',
            },
            {
                imageUrl : '/assets/images/Parquet-intérieur.png',
                title: 'PANNEAUX',
                // description: 'Parquet intérieur',
            },
        ],
        hasInput: false,
        inputLabel: '',
        inputDescription: 'Dans le cadre d’une isolation en Sarking, précisez la composition totale',
    },
]

export default toitureItemData;